package com.karawek.core.auth.model

import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.screen.Screen

data class AuthenticationInfo(
    val session: AuthSession,
    val user: AuthenticatedUser,
)

@Parcelize
data class AuthenticatedUser(
    val firstName: String? = null,
    val middleName: String? = null,
    val lastName: String? = null,
    val emailAddresses: List<String> = emptyList(),
    val phoneNumbers: List<String> = emptyList(),
    val profilePictureUrl: String? = null,
): Screen
